import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface FeaturePreviewDialogData {
    features: any[];
    columns: string[];
}

@Component({
    selector: 'app-feature-preview-dialog',
    templateUrl: './feature-preview-dialog.component.html',
    styleUrls: ['./feature-preview-dialog.component.scss'],
    standalone: false,
})
export class FeaturePreviewDialogComponent {
    constructor(
        public dialogRef: MatDialogRef<FeaturePreviewDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: FeaturePreviewDialogData
    ) {}

    close(): void {
        this.dialogRef.close();
    }
}
